import styled from 'styled-components';
import CommandOutputContainer from 'components/CommandOutputContainer';
import { colors } from 'styleguide';

export default styled(CommandOutputContainer)`
    color: ${colors.redFroly};
`;
